            
<template>  
  <div>    
  	<div class="modalsave" v-show="saveConfig.capa"></div>
    <validation-observer v-slot="{ invalid }">
      <b-form  inline style="margin-bottom:15px" novalidate>
        <b-row>
                    <sw-inputs
                      inputTabla="info_orden"
                      inputCampo="id_datos_pacientes">
                    </sw-inputs>
                    <sw-inputs
                      inputTabla="info_orden"
                      inputCampo="fecha">
                    </sw-inputs>
                    <sw-inputs
                      inputTabla="info_orden"
                      inputCampo="consecutivo">
                    </sw-inputs>
                    <sw-inputs
                      inputTabla="examen_diagnosticos"
                      inputCampo="uso">
                    </sw-inputs> 
                    <sw-inputs
                      inputTabla="examen_diagnosticos"
                      inputCampo="lente">
                    </sw-inputs> 
                    <sw-inputs
                      inputTabla="examen_diagnosticos"
                      inputCampo="aumento">
                    </sw-inputs> 
                    <sw-inputs
                      inputTabla="examen_diagnosticos"
                      inputCampo="alt_bf">
                    </sw-inputs> 
                    <sw-inputs
                      inputTabla="info_orden"
                      inputCampo="id_datos_proveedores_lente">
                    </sw-inputs>
                    <sw-inputs
                      inputTabla="info_orden"
                      inputCampo="color">
                    </sw-inputs>
                    <sw-inputs
                      inputTabla="info_orden"
                      inputCampo="filtro">
                    </sw-inputs>
                    <sw-inputs
                      inputTabla="info_orden"
                      inputCampo="montura">
                    </sw-inputs>
                    <sw-inputs
                      inputTabla="info_orden"
                      inputCampo="id_datos_proveedores_montura">
                    </sw-inputs>                   
                    <sw-inputs
                      inputTabla="examen_diagnosticos"
                      inputCampo="observacion"
                      :lg="6"
                      :md="6">
                    </sw-inputs>
                    <sw-inputs
                      inputTabla="info_orden"
                      inputCampo="fecha_entrega">
                    </sw-inputs>
                    <b-col md="12">
                      <table class="table" style="width:100%;margin-top:10px">
                        <thead class="thead-light text-center">
                          <tr>
                            <th>RX</th>
                            <th>ESF</th>
                            <th>CIL</th>                            
                            <th>EJE</th>
                            <th>ADD</th>
                            <th>DP</th>
                          </tr>
                        </thead>
                        <tbody  class="text-center">
                          <tr >
                            <td style="font-weight:bold">OD</td>
                            <td>
                              {{dataForm[namePath].examen_diagnosticos.od_esf}}
                            </td>
                            <td>
                              {{dataForm[namePath].examen_diagnosticos.od_cil}}
                            </td>
                            <td>
                              {{dataForm[namePath].examen_diagnosticos.od_eje}}
                            </td>
                            <td>
                              {{dataForm[namePath].examen_diagnosticos.od_add}}
                            </td>
                            <td>
                              {{dataForm[namePath].examen_diagnosticos.od_dp}}
                            </td>
                          </tr>
                          <tr>
                            <td style="font-weight:bold">OD</td>
                            <td>
                              {{dataForm[namePath].examen_diagnosticos.oi_esf}}
                            </td>
                            <td>
                              {{dataForm[namePath].examen_diagnosticos.oi_cil}}
                            </td>
                            <td>
                              {{dataForm[namePath].examen_diagnosticos.oi_eje}}
                            </td>
                            <td>
                              {{dataForm[namePath].examen_diagnosticos.oi_add}}
                            </td>
                            <td>
                              {{dataForm[namePath].examen_diagnosticos.oi_dp}}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </b-col>
                    <sw-inputs
                      inputTabla="info_ventas"
                      inputCampo="total">
                    </sw-inputs>
                    <sw-inputs
                      inputTabla="info_ventas"
                      inputCampo="abono">
                    </sw-inputs>
                    <b-form-group
                        :label="datadb.info_ventas.saldo.label"
                      >                      
                        <b-input-group size="sm" prepend="$" append="">
                          <b-form-input v-model="saldo" disabled trim></b-form-input>
                        </b-input-group>
                    </b-form-group>
        </b-row>
      </b-form>
      <footer  id="modal-1___BV_modal_footer_" class="modal-footer" style="margin: 0 -15px; padding: 0">
          <sw-saveform
            nameBtn="registro"
            :invalid="invalid"
            @save="save"
            >
          </sw-saveform>
      </footer>
    </validation-observer>
  </div> 
</template>
<script>
import { mapState } from "vuex"
import { ValidationObserver } from 'vee-validate'
import SwInputs  from '@/components/forms/inputs.vue'
import SwSaveform from '@/components/forms/saveForm.vue'
export default 
{
  name: 'paciente',
  components: {
    SwInputs,
    ValidationObserver,
    SwSaveform        
  },
  props: {
  },
  computed: 
  {
    saldo()
    {
      let newSaldo=this.dataForm[this.namePath].info_ventas.total-this.dataForm[this.namePath].info_ventas.abono
      if(newSaldo<0)
      {
        newSaldo=0
        this.updateDataForm({state: 'info_ventas/abono', data: this.dataForm[this.namePath].info_ventas.total})
      }
      this.updateDataForm({state: 'info_ventas/saldo', data: newSaldo})
      return newSaldo
    }
  },
  created(){
    if(this.indexData!==false)
    {      
      if(this.namePath==='orden_antiguos')
      {
        this.updateDataForm({state: 'info_examens', data: this.dataGet[this.namePath].data[this.indexData].info_examens})
        this.updateDataForm({state: 'info_orden/id_datos_pacientes', data: this.dataGet[this.namePath].data[this.indexData].info_examens.id_datos_pacientes})
        this.updateDataForm({state: 'info_ventas/id_datos_pacientes', data: this.dataGet[this.namePath].data[this.indexData].info_examens.id_datos_pacientes})
        this.updateDataForm({state: 'info_orden/id_info_examens', data: this.dataGet[this.namePath].data[this.indexData].info_examens.id})
        this.updateDataForm({state: 'info_orden/consecutivo', data: this.consecutivo})
        this.updateDataForm({state: 'info_orden/fecha', data: this.fecha().fecha.minHoy})
        this.updateDataForm({state: 'examen_diagnosticos',data: this.dataGet[this.namePath].data[this.indexData].examen_diagnosticos})
      }
      if(this.namePath==='orden_registro')
      {
        this.updateDataForm({state: 'info_examens', data: this.dataGet[this.namePath].data[this.indexData].info_examens})
        this.updateDataForm({state: 'info_orden/id_datos_pacientes', data: this.dataGet[this.namePath].data[this.indexData].info_examens.id_datos_pacientes})
        this.updateDataForm({state: 'info_ventas/id_datos_pacientes', data: this.dataGet[this.namePath].data[this.indexData].info_examens.id_datos_pacientes})
        this.updateDataForm({state: 'info_orden/id_info_examens', data: this.dataGet[this.namePath].data[this.indexData].info_examens.id})
        this.updateDataForm({state: 'info_orden/consecutivo', data: this.consecutivo})
        this.updateDataForm({state: 'info_orden/fecha', data: this.fecha().fecha.minHoy})
        this.updateDataForm({state: 'examen_diagnosticos',data: this.dataGet[this.namePath].data[this.indexData].examen_diagnosticos})
      }
      if(this.namePath==='orden_pendientes')
      {
        this.updateDataForm({state: 'info_orden',data: this.dataGet[this.namePath].data[this.indexData].info_orden})
        this.updateDataForm({state: 'info_ventas',data: this.dataGet[this.namePath].data[this.indexData].info_ventas})
        this.updateDataForm({state: 'examen_diagnosticos',data: this.dataGet[this.namePath].data[this.indexData].examen_diagnosticos})
      }
      
    }    
  },
  methods: {
    save(event)
    {
      this.$emit('save',{save: false, ftn: 'registroOrdenFtn' })
    }
  }
}
</script>
<style>
</style>